<template>
  <div>
    <div v-if="isLoading" class="fixed inset-0 backdrop-blur-lg bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-black/50 bg-opacity-95 p-6  mx-36 rounded-lg shadow-lg flex flex-col items-center">
        <div class="animate-spin rounded-full h-16 w-16 border-t-4 border-orange-300 border-solid"></div>
        <p class="mt-4 text-white text-lg">در حال بارگزاری ...</p>
      </div>
    </div>

    <div class="mx-auto">
      <div class="bg-white/20 backdrop-blur-md rounded-xl shadow-xl overflow-hidden border border-white/30">
        <div class="bg-gradient-to-r from-blue-500 to-emerald-600 p-6 text-white ">
          <h1 class="text-2xl font-bold text-center">پکینگ ورود کالای خارجی</h1>
          <p class="text-center text-white mt-2">فایل خود را آپلود کنید و گزارش را دریافت نمایید</p>
        </div>
        <div
            v-if="popupVisible"
            class="fixed inset-0 bg-black/30 backdrop-blur-sm z-40"
            @click="popupVisible = false"
        ></div>
        <div
            v-if="popupVisible"
            class="fixed z-50 bg-white/90 backdrop-blur-md shadow-lg rounded-lg p-4 border border-gray-200 max-w-xs w-full"
            :style="{
                top: `${popupTopPosition}px`,
                left: '50%',
                transform: 'translateX(-50%)'
              }"
        >
          <div class="text-sm font-medium text-gray-700 mb-3">این ستون را به عنوان:</div>
          <button
              v-for="type in ['p','g','n','b','qpb','bq','tq','ta','s']"
              :key="type"
              @click.stop="setHeaderType(type)"
              class="block w-full text-right px-4 py-2 text-sm rounded-lg mt-2 transition-colors"
              :class="headerColors[type].bg + ' ' + headerColors[type].text"
          >
            {{ headerTypes[type] }}
          </button>

          <button
              @click.stop="popupVisible = false"
              class="block w-full text-right px-4 py-2 text-sm hover:bg-gray-100 text-gray-600 rounded-lg mt-3 transition-colors"
          >
            انصراف
          </button>
        </div>

        <div class="px-8 pt-6">
          <div class="flex items-center justify-between relative">
            <!-- Step 1: Upload -->
            <div class="flex flex-col items-center z-10 cursor-pointer" @click="resetForm">
              <div :class="[
                'hover:bg-blue-400 w-10 h-10 rounded-full flex items-center justify-center text-white font-bold',
                rows.length ? 'bg-green-500' : 'bg-blue-500'
              ]">
                1
              </div>
              <span class="mt-2 text-sm font-medium">آپلود فایل</span>
            </div>

            <!-- Connector line -->
            <div class="absolute h-1 w-full bg-gray-200 top-5"></div>
            <div
                :class="[
                'absolute h-1 bg-blue-500 top-5 transition-all duration-500',
                rows.length ? 'w-full' : 'w-0'
              ]"
            ></div>

            <!-- Step 2: Preview -->
            <div class="flex flex-col items-center z-10">
              <div :class="[
                'w-10 h-10 rounded-full flex items-center justify-center text-white font-bold',
                rows.length ? 'bg-blue-500' : 'bg-gray-300'
              ]">
                2
              </div>
              <span class="mt-2 text-sm font-medium">پیش نمایش داده‌ها</span>
            </div>

            <!-- Step 3: Generate -->
            <div class="flex flex-col items-center z-10">
              <div :class="[
                'w-10 h-10 rounded-full flex items-center justify-center text-white font-bold',
                reportResult ? 'bg-green-500' : rows.length ? 'bg-gray-300' : 'bg-gray-300'
              ]">
                3
              </div>
              <span class="mt-2 text-sm font-medium">تولید گزارش</span>
            </div>
          </div>
        </div>

        <!-- Main content -->
        <div class="p-8">
          <div v-if="!rows.length" class="transition-all duration-300">
            <div v-if="!manualMode" class="cursor-pointer hover:bg-blue-50 rounded-xl">
              <div
                  class="border-2 border-dashed border-blue-300 rounded-xl bg-white/50 p-8 text-center"
                  @click="openFileDialog"
                  @dragover.prevent="dragover = true"
                  @dragleave="dragover = false"
                  @drop.prevent="handleDrop"
                  :class="{'border-blue-500 bg-blue-50/50': dragover}"
              >
                <div class="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24"
                       stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
                  </svg>
                </div>
                <h3 class="text-lg font-medium text-gray-800">فایل اکسل خود را اینجا رها کنید</h3>
                <p class="mt-1 text-sm text-gray-500">یا برای انتخاب فایل کلیک کنید</p>

                <!-- Hidden file input -->
                <input
                    type="file"
                    ref="fileInput"
                    accept=".xls,.xlsx"
                    @change="handleFileChange"
                    class="hidden"
                />

                <p v-if="selectedFile" class="mt-4 text-sm text-green-600 font-medium">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline-block mr-1" viewBox="0 0 20 20"
                       fill="currentColor">
                    <path fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"/>
                  </svg>
                  فایل انتخاب شده: {{ selectedFile.name }}
                </p>

                <div v-if="loading" class="mt-6">
                  <div class="flex flex-col items-center">
                    <svg class="animate-spin h-8 w-8 text-blue-600 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none"
                         viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span class="text-sm text-gray-600">در حال آپلود فایل...</span>
                  </div>
                </div>

                <div v-if="error" class="mt-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
                  {{ error }}
                </div>
              </div>
              <div class="mt-4 text-center">
                <button type="button" @click="manualMode = true" class="text-sm text-blue-600 hover:text-blue-800 underline">
                  ایجاد لیست دستی (بدون آپلود اکسل)
                </button>
              </div>
            </div>

            <div v-else class="border border-gray-200 rounded-xl bg-white/60 p-4">
              <div class="flex items-center justify-between mb-4">
                <h3 class="text-lg font-medium text-gray-800">ایجاد لیست دستی</h3>
                <button type="button" @click="cancelManualMode" class="text-sm text-gray-500 hover:text-gray-700">
                  انصراف و بازگشت به آپلود اکسل
                </button>
              </div>

              <p class="text-xs text-gray-500 mb-3">
                ستون‌ها و ردیف‌های مورد نیاز را اضافه کنید و مقادیر را وارد کنید. بعد از ایجاد لیست، مثل حالت آپلود اکسل، روی هر ستون کلیک کنید تا نوع آن را مشخص کنید.
              </p>

              <div class="overflow-x-auto border border-gray-200 rounded-lg">
                <table class="min-w-full divide-y divide-gray-200 text-sm">
                  <thead class="bg-gray-100">
                  <tr>
                    <th v-for="col in manualColumnCount" :key="col" class="px-3 py-2 text-xs font-medium text-gray-500">
                      <div class="flex items-center justify-center gap-1">
                        <span>ستون {{ col }}</span>
                        <button v-if="manualColumnCount > 1" type="button" @click="removeManualColumn(col - 1)"
                                class="text-red-400 hover:text-red-600" title="حذف ستون">✕</button>
                      </div>
                    </th>
                    <th class="px-3 py-2">
                      <button type="button" @click="addManualColumn" class="text-blue-500 hover:text-blue-700 text-xs">
                        + ستون
                      </button>
                    </th>
                  </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="(row, i) in manualRows" :key="i">
                    <td v-for="col in manualColumnCount" :key="col" class="px-2 py-1">
                      <input v-model="row[col - 1]" class="w-full border border-gray-200 rounded px-2 py-1 text-xs">
                    </td>
                    <td class="px-2 py-1 text-center">
                      <button type="button" @click="removeManualRow(i)" class="text-red-500 hover:text-red-700" title="حذف ردیف">✕</button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="flex items-center justify-between mt-4">
                <div class="flex items-center gap-2">
                  <button type="button" @click="addManualRow"
                          class="px-3 py-1.5 bg-gray-100 hover:bg-gray-200 rounded-lg text-sm text-gray-700">
                    + افزودن ردیف
                  </button>
                  <button type="button" @click="openCurrencyPopup"
                          class="px-3 py-1.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 rounded-lg text-sm">
                    محاسبه قیمت ارزی
                  </button>
                </div>
                <button
                    type="button"
                    @click="submitManualRows"
                    :disabled="!hasManualData"
                    :class="[
                      'px-4 py-2 rounded-lg font-medium transition-all',
                      hasManualData ? 'bg-green-600 text-white shadow-md hover:bg-green-700' : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    ]"
                >
                  ایجاد لیست
                </button>
              </div>
              <div v-if="error" class="mt-4 p-3 bg-red-50 text-red-600 rounded-lg text-sm">
                {{ error }}
              </div>

              <div v-if="currencyPopupVisible" class="fixed inset-0 bg-black/30 backdrop-blur-sm z-40" @click="currencyPopupVisible = false"></div>
              <div v-if="currencyPopupVisible"
                   class="fixed z-50 bg-white shadow-lg rounded-lg p-4 border border-gray-200 max-w-xs w-full"
                   style="top: 150px; left: 50%; transform: translateX(-50%);">
                <div class="text-sm font-medium text-gray-700 mb-3">محاسبه قیمت ارزی</div>
                <label class="block text-xs text-gray-600 mb-1">ستون قیمت ارزی</label>
                <select v-model.number="currencySourceColumn" class="w-full border border-gray-200 rounded px-2 py-1.5 text-sm mb-3">
                  <option v-for="col in manualColumnCount" :key="col" :value="col - 1">ستون {{ col }}</option>
                </select>
                <label class="block text-xs text-gray-600 mb-1">قیمت ارز (نرخ تبدیل)</label>
                <input v-model="currencyRateInput" type="text" placeholder="مثلاً 55000"
                       class="w-full border border-gray-200 rounded px-2 py-1.5 text-sm mb-4">
                <div class="flex gap-2">
                  <button type="button" @click="applyCurrencyCalculation"
                          class="flex-1 bg-indigo-600 text-white rounded-lg py-2 text-sm hover:bg-indigo-700">
                    محاسبه و ایجاد ستون
                  </button>
                  <button type="button" @click="currencyPopupVisible = false"
                          class="flex-1 bg-gray-100 text-gray-700 rounded-lg py-2 text-sm hover:bg-gray-200">
                    انصراف
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="rows.length" class="transition-all duration-300">
            <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div class="p-4 border-b border-gray-200 bg-gray-50">
                <h2 v-if="!reportResult" class="text-lg font-semibold text-gray-800">پیش نمایش داده‌های استخراج شده</h2>

                <div class="mt-4 grid grid-cols-3 md:grid-cols-3 gap-4" v-if="!reportResult">
                  <div class=" flex justify-end" v-if="!reportResult">
                    <button
                        @click="createExtractedReport"
                        :disabled="!canCreateReport || creatingReport"
                        :class="[
                      'px-3 py-1 rounded-lg font-medium transition-all flex items-center text-center',
                      canCreateReport && !creatingReport
                        ? 'bg-green-600 text-white shadow-md hover:bg-green-700 hover:shadow-lg'
                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    ]"
                    >
                    <span v-if="creatingReport">
                      <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block"
                           xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      در حال ساخت گزارش...
                    </span>
                      <span v-else>
                      تولید گزارش نهایی
                    </span>
                    </button>
                  </div>

                </div>
                <div class="mx-[auto] w-[70%] items-center" v-if="reportResult">
                  <div class="bg-gradient-to-r from-green-500 to-emerald-600 p-6 text-white ">
                    <div class="flex items-center justify-between">
                      <div class="flex items-center">
                        <div class="bg-white/20 p-3 rounded-full mr-4 ml-2">
                          <i class="fas fa-file-excel text-2xl p-2"></i>
                        </div>
                        <div>
                          <h2 class="text-xl font-bold"> پکینگ با  موفقیت ساخته شد</h2>
                          <p class="text-green-100">نتایج پردازش فایل اکسل آپلود شده</p>
                        </div>
                      </div>
                      <div class="success-animation">
                        <i class="fas fa-check-circle text-3xl text-white"></i>
                      </div>
                    </div>
                  </div>
                  <!-- بدنه گزارش -->
                  <div class="p-6">
                    <!-- خلاصه نتایج -->
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                      <div class="bg-green-50 p-4 rounded-lg border border-green-200 text-center">
                        <div class="text-green-500 mb-2">
                          <i class="fas fa-file-import text-2xl"></i>
                        </div>
                        <h3 class="text-sm text-green-800">شناسه بسته</h3>
                        <p class="text-2xl font-bold text-green-900">{{ reportResult.package_id }}</p>
                      </div>

                      <div class="bg-blue-50 p-4 rounded-lg border border-blue-200 text-center">
                        <div class="text-blue-500 mb-2">
                          <i class="fas fa-list-ol text-2xl"></i>
                        </div>
                        <h3 class="text-sm text-blue-800">تعداد سفارش‌های ایجاد شده</h3>
                        <p class="text-2xl font-bold text-blue-900">{{ reportResult.rows_created }}</p>
                      </div>
                    </div>

                    <!-- اعلان‌ها -->
                    <div class="mb-6" v-if="reportResult.notifications">
                      <h3 class="text-sm font-medium text-gray-700 mb-2">اعلان‌ها و هشدارها:</h3>
                      <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                        <div class="flex items-start">
                          <div class="flex-shrink-0">
                            <i class="fas fa-exclamation-circle text-yellow-500 mt-1"></i>
                          </div>
                          <div class="mr-3">
                            <p v-for="n in reportResult.notifications" class="text-sm text-yellow-700">{{ n }}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- اقدامات بعدی -->
                    <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
                      <h3 class="text-sm font-medium text-gray-700 mb-3">اقدامات بعدی:</h3>
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <button
                            @click="goList()"
                            class="flex items-center justify-center px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition">
                          <i class="fas fa-list ml-2"></i>
                           مشاهده گزارش کامل پکینگ ها
                        </button>
                        <button
                            @click="goDetail(reportResult.package_id)"
                            class="flex items-center justify-center px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition">
                          <i class="fas fa-eye ml-2"></i>
                          تکمیل اولیه
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="bg-gray-100 px-6 py-4 border-t border-gray-200">
                    <div class="flex items-center justify-between">
                      <button class="flex items-center text-green-600 hover:text-green-700 font-medium"
                              @click="resetForm">
                        <i class="fas fa-plus-circle ml-2"></i>
                        آپلود فایل جدید
                      </button>
                      <span class="text-sm text-gray-500">زمان پردازش: کمتر از ۱ دقیقه</span>
                    </div>
                  </div>
                </div>

              </div>

              <p v-if="matchLoading" class="p-3 text-blue-600">در حال تطبیق GTIN ...</p>
              <div v-if="matchError" class="p-3 text-red-600">{{ matchError }}
                <button @click="refreshPackingMatches" class="underline mr-2">تلاش مجدد</button>
              </div>
              <div class="overflow-x-auto" v-if="!reportResult">
                <table class="min-w-full divide-y divide-gray-200" v-if="rows && rows.length">
                  <thead class="bg-gray-100">
                  <tr>
                    <th
                        @click="showHeaderPopup(h)"
                        v-for="(h, idx) in headers" :key="idx"
                        scope="col"
                        class="text-center items-center px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase cursor-pointer hover:bg-blue-200 hover:text-white"
                    >
                      <div class=" items-center text-center">
                          <span v-if="!typeForHeader(idx)" class="m-[auto]">
                            {{ headerLabel(idx) }}
                          </span>
                        <span v-else
                              class="justify-center m-[auto] text-xs px-2 py-0.5 rounded-full"
                              :class="{
                                  'bg-orange-100 text-orange-600': typeForHeader(idx) === 'g',
                                  'bg-green-100 text-green-800': typeForHeader(idx) === 'n',
                                  'bg-blue-100 text-blue-800': typeForHeader(idx) === 'p',
                                  'bg-purple-100 text-purple-800': typeForHeader(idx) === 'b',
                                  'bg-pink-100 text-pink-800': typeForHeader(idx) === 'qpb',
                                  'bg-purple-100 text-pink-800': typeForHeader(idx) === 's',
                                  'bg-yellow-100 text-yellow-800': typeForHeader(idx) === 'tq',
                                  'bg-red-100 text-red-800': typeForHeader(idx) === 'ta',
                                  'bg-blue-800 text-blue-50': typeForHeader(idx) === 'bq',
                                  'bg-gray-100 text-gray-600': typeForHeader(idx) === 'u'
                                }">
                          {{ headerTypes[typeForHeader(idx)] }}
                          </span>
                      </div>
                    </th>
                    <th v-if="selectedHeaders.s != null" class="p-2">محصول مقصد</th>
                  </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="(row, i) in visiblePackingRows" :key="i" class="hover:bg-gray-50">
                    <td
                        v-for="(h, index) in headers"
                        :key="h"
                        class=" text-xs text-gray-800 text-opacity-50 hover:bg-blue-200 hover:text-white items-center text-center py-2"
                        :class="{
                                  'bg-orange-100 text-orange-600': typeForHeader(index) === 'g',
                                  'bg-green-100 text-green-800': typeForHeader(index) === 'n',
                                  'bg-blue-100 text-blue-800': typeForHeader(index) === 'p',
                                  'bg-purple-100 text-purple-800': typeForHeader(index) === 'b',
                                  'bg-pink-100 text-pink-800': typeForHeader(index) === 'qpb',
                                  'bg-yellow-100 text-yellow-800': typeForHeader(index) === 'tq',
                                  'bg-red-100 text-red-800': typeForHeader(index) === 'ta',
                                  'bg-blue-800 text-blue-50': typeForHeader(index) === 'bq',
                                  'bg-gray-100 text-gray-600': typeForHeader(index) === 'u',
                                  'bg-purple-100 text-purple-600': typeForHeader(index) === 's'
                                }"
                        @click="showHeaderPopup(h)"
                    >
                      <span v-if="index !== 0">
                        {{ row && row[h] !== undefined ? truncateText(row[h]) : '' }}
                      </span>
                      <img
                          v-else
                          :src="img_source(row[h])"
                          class="w-10 h-10 rounded-lg object-cover border border-gray-200 shadow-sm mr-2"
                      >

                    </td>
                    <td v-if="selectedHeaders.s != null" class="p-3 min-w-[260px]">
                      <div v-if="matchRows[(previewPage - 1) * 10 + i]">
                        <div class="text-xs mb-2">GTIN: {{ matchRows[(previewPage - 1) * 10 + i].gtin || 'بدون GTIN' }}</div>
                        <label class="flex gap-2 mb-2 text-sm">
                          <input type="checkbox" v-model="matchRows[(previewPage - 1) * 10 + i].mode"
                            true-value="new" false-value="existing"
                            @change="toggleNewPackingProduct(matchRows[(previewPage - 1) * 10 + i])">
                          محصول جدید ایجاد شود
                        </label>
                        <div v-if="matchRows[(previewPage - 1) * 10 + i].mode !== 'new'">
                          <label v-for="p in matchRows[(previewPage - 1) * 10 + i].products" :key="p.id"
                            class="flex gap-2 items-center p-2 border rounded mb-1 cursor-pointer">
                            <input type="radio" :name="'packing-product-' + ((previewPage - 1) * 10 + i)"
                              :value="p.id" v-model="matchRows[(previewPage - 1) * 10 + i].product_id">
                            <img v-if="p.image" :src="img_source(p.image)" class="w-10 h-10 object-cover rounded">
                            <span class="text-xs">{{ p.name }}<br>شناسه: {{ p.id }} — GTIN: {{ p.gtin }}
                              <span v-if="p.variation_of_id"><br>تنوع: {{ p.variation_name }} (والد {{ p.variation_of_id }})</span>
                            </span>
                          </label>
                          <p v-if="!matchRows[(previewPage - 1) * 10 + i].products.length" class="text-xs text-red-600">محصولی یافت نشد؛ گزینه محصول جدید را انتخاب کنید.</p>
                        </div>
                      </div>
                    </td>
                  </tr>

                  </tbody>
                </table>
                <div class="flex items-center justify-center gap-4 p-3">
                  <button :disabled="previewPage <= 1" @click="previewPage--" class="px-3 py-1 border rounded disabled:opacity-40">قبلی</button>
                  <span>صفحه {{ previewPage }} از {{ previewPages }}</span>
                  <button :disabled="previewPage >= previewPages" @click="previewPage++" class="px-3 py-1 border rounded disabled:opacity-40">بعدی</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import packingProductChoices from './packingProductChoices'

const MANUAL_DRAFT_KEY = 'chinaPackingManualListDraft'

export default {
  mixins: [packingProductChoices],
  name: 'ManagerEntrancePackageUpload',
  props: { partnerMode: { type: Boolean, default: false } },
  data() {
    return {
      popupVisible: false,
      isLoading: false,
      clickedHeader: null,
      selectedFile: null,
      selectedHeaders: {},
      headerTypes: {
        tq: "تعداد کل",
        s: "GTIN / SKU",
        n: "نام اولیه",
        p: "قیمت اولیه",
        g: "کد محصول",
        b: "چیدمان کارتون",
        qpb: "تعداد در هر کارتون",
        bq: "تعداد کارتون",
      },
      headerColors: {
        p: {bg: 'hover:bg-blue-50', text: 'text-blue-600', spanBg: 'bg-blue-100', spanText: 'text-blue-800'},
        g: {bg: 'hover:bg-orange-50', text: 'text-orange-600', spanBg: 'bg-orange-100', spanText: 'text-orange-600'},
        n: {bg: 'hover:bg-green-50', text: 'text-green-600', spanBg: 'bg-green-100', spanText: 'text-green-800'},
        b: {bg: 'hover:bg-purple-50', text: 'text-purple-600', spanBg: 'bg-purple-100', spanText: 'text-purple-800'},
        qpb: {bg: 'hover:bg-indigo-50', text: 'text-indigo-600', spanBg: 'bg-pink-100', spanText: 'text-pink-800'},
        tq: {bg: 'hover:bg-pink-50', text: 'text-pink-600', spanBg: 'bg-yellow-100', spanText: 'text-yellow-800'},
        ta: {bg: 'hover:bg-red-50', text: 'text-red-600', spanBg: 'bg-red-100', spanText: 'text-red-800'},
        bq: {bg: 'hover:bg-blue-50', text: 'text-blue-800', spanBg: 'bg-blue-800', spanText: 'text-blue-50'},
        u: {bg: 'hover:bg-gray-100', text: 'text-gray-600', spanBg: 'bg-gray-100', spanText: 'text-gray-600'},
        s: {bg: 'hover:bg-purple-50', text: 'text-purple-600', spanBg: 'bg-purple-100', spanText: 'text-purple-600'},

      },
      formatType: 'indexed_dict',
      startCol: 1,
      loading: false,
      error: '',
      rows: [],
      headers: [],
      popupTopPosition: 100,
      uploadedFileId: null,
      selectedCodeHeader: null,
      selectedOrderHeader: null,
      creatingReport: false,
      reportResult: null,
      dragover: false,
      manualMode: false,
      manualRows: [],
      manualColumnCount: 3,
      currencyPopupVisible: false,
      currencySourceColumn: 0,
      currencyRateInput: '',
    };
  },
  computed: {
    manualDraftKey() {
      return this.partnerMode ? `partner:${this.user && this.user.id || 'current'}:${MANUAL_DRAFT_KEY}` : MANUAL_DRAFT_KEY
    },
    canCreateReport() {
      return this.uploadedFileId && this.selectedHeaders && this.choicesReady;
    },
    hasManualData() {
      return this.manualRows.some(row => row.some(v => String(v || '').trim() !== ''));
    },
  },
  watch: {
    manualRows: {
      handler() {
        this.schedulePersistManualDraft();
      },
      deep: true,
    },
    manualColumnCount() {
      this.schedulePersistManualDraft();
    },
  },
  methods: {
    schedulePersistManualDraft() {
      clearTimeout(this._manualDraftTimer);
      this._manualDraftTimer = setTimeout(() => this.persistManualDraft(), 300);
    },
    persistManualDraft() {
      try {
        if (this.hasManualData) {
          localStorage.setItem(this.manualDraftKey, JSON.stringify({
            manualRows: this.manualRows,
            manualColumnCount: this.manualColumnCount,
          }));
        } else {
          localStorage.removeItem(this.manualDraftKey);
        }
      } catch (e) {
      }
    },
    restoreManualDraft() {
      try {
        const raw = localStorage.getItem(this.manualDraftKey);
        if (!raw) return;
        const draft = JSON.parse(raw);
        if (draft && Array.isArray(draft.manualRows) && draft.manualRows.length) {
          this.manualRows = draft.manualRows;
          this.manualColumnCount = draft.manualColumnCount || (draft.manualRows[0] ? draft.manualRows[0].length : 3);
          this.manualMode = true;
        }
      } catch (e) {
      }
    },
    clearManualDraft() {
      try {
        localStorage.removeItem(this.manualDraftKey);
      } catch (e) {
      }
    },
    truncateText(text) {
      if (!text) return ''
      return text.length > 35 ? text.slice(0, 35) + '...' : text
    },
    setHeaderType(type) {
      const headerIndex = Number(this.clickedHeader);

      if (this.selectedHeaders[type] === headerIndex) {
        this.$delete(this.selectedHeaders, type);
      } else {
        for (const key in this.selectedHeaders) {
          if (this.selectedHeaders[key] === headerIndex) {
            this.$delete(this.selectedHeaders, key);
          }
        }
        this.$set(this.selectedHeaders, type, headerIndex);
      }

      this.popupVisible = false;
    },

    headerLabel(index) {
      return `ستون ${index + 1}`
    },
    typeForHeader(headerIndex) {
      for (const [type, idx] of Object.entries(this.selectedHeaders)) {
        if (idx === headerIndex) return type
      }
      return null
    },

    handleFileChange(e) {
      this.isLoading = true
      console.log(this.isLoading)
      this.selectedFile = e.target.files[0];
      this.error = '';
      this.rows = [];
      this.headers = [];
      this.uploadedFileId = null;
      this.selectedCodeHeader = null;
      this.selectedOrderHeader = null;
      this.reportResult = null;
      this.uploadFile();

    },
    openFileDialog() {
      this.$refs.fileInput.click();
    },

    handleDrop(e) {
      this.isLoading = true
      console.log(this.isLoading)
      this.dragover = false;
      if (e.dataTransfer.files.length) {
        this.selectedFile = e.dataTransfer.files[0];
        this.uploadFile(); // Automatically upload when file is dropped
      }
    },

    resetForm() {
      this.selectedFile = null;
      this.error = '';
      this.rows = [];
      this.headers = [];
      this.uploadedFileId = null;
      this.selectedCodeHeader = null;
      this.selectedOrderHeader = null;
      this.reportResult = null;
      this.isLoading = false
      this.manualMode = false;
      this.manualRows = [];
      this.manualColumnCount = 3;
      this.clearManualDraft();

    },

    emptyManualRow() {
      return new Array(this.manualColumnCount).fill('');
    },
    addManualRow() {
      this.manualRows.push(this.emptyManualRow());
    },
    removeManualRow(i) {
      this.manualRows.splice(i, 1);
    },
    addManualColumn() {
      this.manualColumnCount++;
      this.manualRows.forEach(row => row.push(''));
    },
    removeManualColumn(colIndex) {
      if (this.manualColumnCount <= 1) return;
      this.manualColumnCount--;
      this.manualRows.forEach(row => row.splice(colIndex, 1));
    },
    cancelManualMode() {
      this.manualMode = false;
      this.manualRows = [];
      this.manualColumnCount = 3;
      this.clearManualDraft();
    },
    openCurrencyPopup() {
      if (!this.manualRows.length) {
        window.alert('ابتدا حداقل یک ردیف اضافه کنید.');
        return;
      }
      this.currencySourceColumn = 0;
      this.currencyRateInput = '';
      this.currencyPopupVisible = true;
    },
    applyCurrencyCalculation() {
      const rate = parseFloat(this.currencyRateInput);
      if (!rate) {
        window.alert('قیمت ارز معتبر وارد کنید.');
        return;
      }
      const sourceCol = this.currencySourceColumn;
      this.addManualColumn();
      const newCol = this.manualColumnCount - 1;
      this.manualRows.forEach(row => {
        const val = parseFloat(row[sourceCol]);
        row.splice(newCol, 1, isNaN(val) ? '' : String(val / rate));
      });
      this.currencyPopupVisible = false;
    },
    submitManualRows() {
      if (this.isLoading) return;
      const nonEmpty = this.manualRows.filter(row => row.some(v => String(v || '').trim() !== ''));
      if (!nonEmpty.length) {
        window.alert('حداقل یک ردیف با اطلاعات را وارد کنید.');
        return;
      }

      // یک ردیف خالی اول اضافه می‌شود چون بک‌اند ردیف اول فایل را به عنوان هدر در نظر می‌گیرد و آن را از داده‌ها حذف می‌کند.
      const headerRow = new Array(this.manualColumnCount).fill('');
      const ws = XLSX.utils.aoa_to_sheet([headerRow, ...nonEmpty]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      const out = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
      const file = new File([out], 'لیست-دستی.xlsx', {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

      this.selectedFile = file;
      this.uploadFile();
    },
    async uploadFile() {
      if (!this.selectedFile) {
        this.error = 'لطفاً فایل انتخاب کنید.';
        return;
      }
      this.isLoading = true;
      this.error = '';
      this.rows = [];
      this.headers = [];
      this.uploadedFileId = null;
      this.selectedCodeHeader = null;
      this.selectedOrderHeader = null;
      this.reportResult = null;

      try {
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        formData.append('format_type', this.formatType);
        formData.append('start_col', this.startCol);

        this.request({
          url: this.endpoint(this.partnerMode ? 'file_handler/uploadPartnerPacking' : 'file_handler/uploadPacking'),
          method: 'post',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          success: (data) => {
            this.uploadedFileId = data.id || null;

            if (!data.rows || !Array.isArray(data.rows)) {
              window.alert('پاسخ سرور شامل rows نیست.');
            }
            this.rows = data.rows;

            const allKeys = new Set();
            this.rows.forEach(r => Object.keys(r).forEach(k => allKeys.add(k)));
            this.headers = Array.from(allKeys).sort((a, b) => {
              const an = parseInt(a), bn = parseInt(b);
              if (!isNaN(an) && !isNaN(bn)) return an - bn;
              if (!isNaN(an)) return -1;
              if (!isNaN(bn)) return 1;
              return a.localeCompare(b);
            });

            this.manualMode = false;
            this.manualRows = [];
            this.manualColumnCount = 3;
            this.clearManualDraft();
            this.isLoading = false;
          },
          error: (err) => {
            this.error = this.packingErrorMessage(err, 'پاسخ سرور دریافت نشد.') + ' لیست دستی شما حفظ شده است.';
            window.alert(this.error);
            this.isLoading = false;
          }
        });

      } catch (err) {
        this.error = 'آپلود انجام نشد. لیست دستی شما حفظ شده، دوباره روی «ایجاد لیست» بزنید.';
        window.alert('خطا رخ داد. لیست دستی شما پاک نشده، دوباره تلاش کنید.');
        this.isLoading = false;
      }
    },

    headerToColumnNumber(header) {
      const parsed = parseInt(header);
      if (!isNaN(parsed)) return parsed;

      const idx = this.headers.indexOf(header);
      if (idx === -1) return null;
      return this.startCol + idx;
    },
    closePostReport() {
      this.$emit('close');
    },

    createExtractedReport() {
      if (!this.canCreateReport) return;
      this.isLoading = true;
      this.creatingReport = true;
      this.error = '';
      this.reportResult = null;

      try {
        if (!this.selectedHeaders || !this.selectedHeaders) {
          window.alert('لطفاً ستون‌های کد رهگیری و سفارش را انتخاب کنید.');
        }

        const body = {
          file_id: this.uploadedFileId,
          selected_headers: this.selectedHeaders,
          ...this.packingChoiceBody(),
        };

        this.request({
          url: this.endpoint('file_handler/extractPacking'),
          method: 'post',
          data: body,
          success: (result) => {
            this.reportResult = result;
            this.isLoading = false;
            this.creatingReport = false;
          },
          error: (err) => {
            this.creatingReport = false;
            this.error = this.packingErrorMessage(err, 'ثبت انجام نشد؛ انتخاب محصولات و اطلاعات ردیف‌ها را بررسی کنید.');
            window.alert(this.error);
            this.isLoading = false;
          }
        });

      } catch (err) {
        window.alert('خطا در ساخت ');
        this.isLoading = false;
        this.creatingReport = false;
      }
    },
    goDetail(id) {
      this.$router.push(`/panel/entrancePackageItemDetail/${id}`)
    },
    goList() {
      this.$router.push(this.partnerMode ? '/panel/partnerExtractedEntrancePackageList' : '/panel/extractedEntrancePackageList')
    },

    showHeaderPopup(header) {
      this.clickedHeader = header;
      this.popupTopPosition = window.scrollY + 100;
      this.popupVisible = true;
    },
    handleClickOutsidePopup(e) {
      if (!this.$el.contains(e.target)) {
        this.popupVisible = false;
      }
    },
    updatePopupPosition() {
      if (this.popupVisible) {
        this.popupTopPosition = window.scrollY + 100;
      }
    },


  },
  mounted() {
    window.addEventListener('scroll', this.updatePopupPosition);
    if (!this.rows.length) this.restoreManualDraft();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updatePopupPosition);
    clearTimeout(this._manualDraftTimer);
  },

};
</script>

<style scoped>
.table-enter-active, .table-leave-active {
  transition: opacity 0.3s ease;
}

.table-enter-from, .table-leave-to {
  opacity: 0;
}

/* Transition effects */
.popup-enter-active,
.popup-leave-active {
  transition: all 0.2s ease;
}

.popup-enter-from,
.popup-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}

.backdrop-enter-active,
.backdrop-leave-active {
  transition: opacity 0.2s ease;
}

.backdrop-enter-from,
.backdrop-leave-to {
  opacity: 0;
}

</style>
